<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <b-button variant="outline-warning" @click="mostrarModalActualizarDatoERP()" size="sm">
      <i class="fa fa-pencil-square-o" aria-hidden="true"/>
    </b-button>

    <b-modal
        v-model="modalCapturarDatosInvisaling"
        title="Capturar datos alineadores"
        hide-footer
    >
      <validation-observer ref="observer" v-slot="{ handleSubmit }" @submit.prevent>

        <div v-if="data != null" class="my-4 text-left">
          <b-row>
            <b-col cols="3">
              <label>Paciente:</label>
            </b-col>
            <b-col cols="9">
              <h6>{{ data.item.nombrePaciente }} ({{ data.item.idPaciente }})</h6>
            </b-col>
          </b-row>

          <b-row v-if="data.item.idPti != null">
            <b-col cols="3">
              <label>PTI:</label>
            </b-col>
            <b-col cols="9">
              <h6>{{ data.item.idPti }}</h6>
            </b-col>
          </b-row>

          <b-row v-if="data.item.nombreClinica != null">
            <b-col cols="3">
              <label>Clínica:</label>
            </b-col>
            <b-col cols="9">
              <h6>{{ data.item.nombreClinica }}</h6>
            </b-col>
          </b-row>

          <b-row v-if="data.item.idTxInvisaling != null">
            <b-col cols="3">
              <label>Tratamiento:</label>
            </b-col>
            <b-col cols="9">
              <h6>{{ data.item.txInvisaling }} ({{ data.item.idTxInvisaling }})</h6>
            </b-col>
          </b-row>

          <b-row v-if="data.item.fechaPago != null">
            <b-col cols="3">
              <label>Fecha pago:</label>
            </b-col>
            <b-col cols="9">
              <h6>{{ data.item.fechaPago | formatoFechaHoraTexto }}</h6>
            </b-col>
          </b-row>

          <b-row v-if="data.item.montoPagado != null">
            <b-col cols="3">
              <label>Monto pagado:</label>
            </b-col>
            <b-col cols="9">
              <h6>{{ data.item.montoPagado | monedaDecimal }}</h6>
            </b-col>
          </b-row>

          <b-row v-if="data.item.noRecibo != null">
            <b-col cols="3">
              <label>Recibo:</label>
            </b-col>
            <b-col cols="9">
              <h6>{{ data.item.noRecibo }}</h6>
            </b-col>
          </b-row>

        </div>

        <b-row style="width: 100%;">
          <b-col cols="12">
            <label># Paciente:</label>
            <validation-provider
                name="validacionIdPaciente"
                :rules="{ required: true }"
                v-slot="slotNumPaciente"
                style="width: 100%">
              <b-form-input
                  placeholder="número"
                  v-model="numPacienteInvisalingSAVE"
                  style="text-align: center; width: 100%;"
              ></b-form-input>
              <validacion
                  :texto="slotNumPaciente.errors[0] ? slotNumPaciente.errors[0] : ''"
              ></validacion>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row style="text-align: center; width: 100%;">
          <b-col cols="6">
            <b-button
                class="mt-3"
                variant="outline-danger"
                block
                @click="cerrarModalActualizarDatoERP()">Cancelar
            </b-button>
          </b-col>
          <b-col cols="6">
            <b-button
                class="mt-3"
                variant="outline-primary"
                block
                @click="handleSubmit(actualizarDatoERP)">Guardar
            </b-button>
          </b-col>
        </b-row>

      </validation-observer>

    </b-modal>
  </div>
</template>

<script>
export default {
  name: "BandejaInvisalingComponenteCapturar",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    loading:false,
    modalCapturarDatosInvisaling: false,
    numPacienteInvisalingSAVE: null
  }),
  props: {
    data: Object,
    resource: Object
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {

    mostrarModalActualizarDatoERP() {
      this.numPacienteInvisalingSAVE = null;
      this.modalCapturarDatosInvisaling = true;
    },
    cerrarModalActualizarDatoERP() {
      this.modalCapturarDatosInvisaling = false;
      this.$emit("_funcionExtra", 1);
    },

    actualizarDatoERP() {

      const params = {
        idBandejaInvisaling: this.data.item.idBandejaInvisaling,
        numPacienteInvisaling: this.numPacienteInvisalingSAVE,
      }

      this.loading = true;

      this.$http
          .post(
              this.$api +
              "invisalign/capturar",
              params
          )
          .then((response) => {
            this.$swal.fire({
              icon: 'success',
              title: response.data.message
            }).then(() => {
              this.$emit("_funcionExtra", 1);
            });
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            this.$swal.fire({
              icon: "error",
              title: "Ocurrio un error",
              text: error.response.data.message,
            });
          });
    }
  }
}
</script>
